import { Box, Fade, Paper } from '@mui/material';
import FullPageLoadingSplash from '@acorn-portal/shared/src/components/loading/FullPageLoadingSplash';
import PageTitle from '@acorn-portal/shared/src/components/text/PageTitle';
import React from 'react';

interface IJourneyCardLayout {
	children: React.ReactNode;
	loading: boolean;
	pageTitle: string;
	loadingMessage?: string;
}

const JourneyCardLayout = ({ children, loading, pageTitle, loadingMessage }: IJourneyCardLayout) => {
	return (
		<FullPageLoadingSplash loading={loading} message={loadingMessage ?? 'Fetching Details...'}>
			<Paper
				elevation={1}
				sx={{
					borderRadius: '8px',
				}}
			>
				<Fade in>
					<Box>
						<Box
							sx={(theme) => ({
								margin: '1rem',
								padding: '1rem',
								[theme.breakpoints.down('md')]: {
									padding: 'unset',
									paddingBottom: '1rem',
								},
							})}
						>
							<PageTitle>{pageTitle}</PageTitle>
							<Box paddingBottom={2} />
							{children}
						</Box>
					</Box>
				</Fade>
			</Paper>
		</FullPageLoadingSplash>
	);
};

export default JourneyCardLayout;
